import { BookingDetails } from '~/lib/api/smartsend/types';
import { Parcel2GoProvider, SmartSendProvider } from '~/lib/consts/providers';

export function BookedItemPanelHeader(
  props: BookingDetails,
  providerName: (provider: string) => string,
  orderLinePrefix?: string
): string {
  if (!props) {
    return `External Booking`;
  }

  if (props.Service?.Provider === SmartSendProvider || props.Service?.Provider === Parcel2GoProvider) {
    return props.Reference || `${orderLinePrefix}${props.OrderLineId}`;
  }

  return `${providerName(props.Service?.Provider)} Ref: ${props.Reference || props.OrderLineId}`;
}
